export { UnderstandingYourResultsDefaultContent } from "./understandingYourResultsDefaultContent";
export { UnderstandingYourResultsOncologyContent } from "./understandingYourResultsOncologyContent";
